import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
// 顺序要求：先设计变量与基础样式，再覆盖 Element Plus 的主题变量
import './styles/main.css';
import './styles/element-overrides.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.mount('#app');
